import { useAuth } from '@clerk/nextjs';
import { isDeveloperMember } from '@firmable/utilities/src/developerAccess';
import { Routes } from '@web/constants/routes';
import { usePathname } from 'next/navigation';

/**
 * Whether the signed-in user only gets the developer portal: the developer role, or any member of an
 * org created through the developer sign-up. `isDeveloperRoute` is true on any /developer page, which
 * covers onboarding, before the user has an org to be a developer in.
 */
export function useIsDeveloper() {
  const { isLoaded, orgId, orgRole, sessionClaims } = useAuth();
  const pathname = usePathname();

  const isDeveloper = !!orgId && isDeveloperMember({ role: orgRole, orgType: sessionClaims?.orgType });
  const isDeveloperRoute = pathname === Routes.developerRoot || !!pathname?.startsWith(`${Routes.developerRoot}/`);

  return { isLoaded, isDeveloper, isDeveloperRoute, isDeveloperExperience: isDeveloper || isDeveloperRoute };
}
